module.exports = __webpack_public_path__ + "gallery-duo.jpg?712be9b4f8cc82ac276e0f196ee10427";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery-duo.jpg
// module id = 383
// module chunks = 0